/*
 * Purpose: Official Autoblocks BrandMark — stacked rounded blocks SVG (autoblocks.ai SSOT)
 * Last modified: 2026-06-26 | Agent
 * Completeness: 98
 */
import {
  BRAND_MARK_ACCENT,
  BRAND_MARK_BLOCKS,
  BRAND_MARK_GHOST,
  BRAND_MARK_VIEW_BOX,
  type BrandMarkGhostAccent,
  type BrandMarkTone,
} from './brand-mark-spec';
import { PRODUCT_NAME } from '@/lib/productTerms';

export type BrandMarkProps = {
  size?: number;
  className?: string;
  /** accent = teal on light surfaces; inverse = white blocks on teal/dark panels */
  tone?: BrandMarkTone;
  ghostAccent?: BrandMarkGhostAccent;
};

export function BrandMark({
  size = 40,
  className,
  tone = 'accent',
  ghostAccent,
}: BrandMarkProps) {
  const blockA = tone === 'inverse' ? '#ffffff' : BRAND_MARK_ACCENT;
  const blockB = tone === 'inverse' ? 'rgba(255,255,255,0.72)' : BRAND_MARK_ACCENT;
  const blockC = tone === 'inverse' ? 'rgba(255,255,255,0.88)' : BRAND_MARK_ACCENT;

  const ghostSpec =
    tone === 'inverse'
      ? ghostAccent === 'lighter'
        ? BRAND_MARK_GHOST.inverseLighter
        : BRAND_MARK_GHOST.inverseDefault
      : ghostAccent === 'darker'
        ? BRAND_MARK_GHOST.accentDarker
        : BRAND_MARK_GHOST.accentDefault;

  const { lowerLeft, lowerRight, upperCenter, ghostCorner } = BRAND_MARK_BLOCKS;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={BRAND_MARK_VIEW_BOX}
      role="img"
      aria-label={PRODUCT_NAME}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={lowerLeft.x}
        y={lowerLeft.y}
        width={lowerLeft.w}
        height={lowerLeft.h}
        rx={lowerLeft.rx}
        fill={blockA}
        opacity={tone === 'inverse' ? 1 : lowerLeft.opacity}
      />
      <rect
        x={lowerRight.x}
        y={lowerRight.y}
        width={lowerRight.w}
        height={lowerRight.h}
        rx={lowerRight.rx}
        fill={blockB}
        opacity={tone === 'inverse' ? 1 : lowerRight.opacity}
      />
      <rect
        x={upperCenter.x}
        y={upperCenter.y}
        width={upperCenter.w}
        height={upperCenter.h}
        rx={upperCenter.rx}
        fill={blockC}
        opacity={tone === 'inverse' ? 1 : upperCenter.opacity}
      />
      <rect
        x={ghostCorner.x}
        y={ghostCorner.y}
        width={ghostCorner.w}
        height={ghostCorner.h}
        rx={ghostCorner.rx}
        fill={ghostSpec.fill}
        opacity={ghostSpec.opacity}
      />
    </svg>
  );
}
